var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"machine-counter-wrapper"},[_c('hr'),_vm._v(" "+_vm._s(_vm.solutionString)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }